import { TextAreaFieldProps } from "@interfaces/uiElementTypes";
import React, { useState, useEffect, ChangeEvent } from "react";

const TextAreaField: React.FC<TextAreaFieldProps> = ({
  id,
  name,
  required = false,
  value,
  onChange,
  label,
  className = "",
  classNameCont = "",
  placeholder = "",
  readOnly = false,
  maxLength,
  onInvalidMessage = "შეავსეთ ველი",
  hasCharacterCounter = false,
}) => {
  const [isLabelVisible, setIsLabelVisible] = useState(false);

  useEffect(() => {
    setIsLabelVisible(value !== "");
  }, [value]);

  const handleTextAreaChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    const newValue = e.target.value;
    setIsLabelVisible(newValue !== "");
    onChange(e);
  };

  const handleBlur = () => {
    if (value.trim() === "") setIsLabelVisible(false);
  };

  const handleInvalid = (e: React.InvalidEvent<HTMLTextAreaElement>) => {
    e.target.setCustomValidity(onInvalidMessage);
  };

  const handleInput = (e: React.FormEvent<HTMLTextAreaElement>) => {
    e.currentTarget.setCustomValidity("");
  };

  return (
    <div
      className={`relative flex w-full items-center justify-center ${classNameCont}`}
    >
      {label && (
        <label
          className={`absolute ${
            isLabelVisible
              ? "top-[5px] text-sm text-gray-400"
              : "top-6 text-base text-black text-opacity-60"
          } pointer-events-none left-6 transition-all duration-200`}
          htmlFor={id}
        >
          {isLabelVisible ? label : placeholder}
        </label>
      )}
      <textarea
        id={id}
        name={name}
        placeholder={label ? "" : placeholder}
        required={required}
        value={value}
        onChange={handleTextAreaChange}
        onBlur={handleBlur}
        onInvalid={handleInvalid}
        onInput={handleInput}
        maxLength={maxLength}
        readOnly={readOnly}
        className={`no-scrollbar items-center pl-2 text-black transition-all duration-200 ${className} ${isLabelVisible ? "pt-6" : "pt-4"} `}
      />
      {hasCharacterCounter && maxLength && (
        <div className="absolute bottom-2 right-2 text-xs text-gray-400">
          {value.length} / {maxLength}
        </div>
      )}
    </div>
  );
};

export default TextAreaField;
